import { render } from "./pdf.svg?vue&type=template&id=3dd501a3"
const script = {}

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__